import * as React from 'react';

export const IconPlan = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 23">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.4.6h-9v13.2h9V.6zM.6.6h12.6v7.8H.6V.6zm12.6 9H.6v13.2h12.6V9.6z"
      fill="#fff"
    />
  </svg>
);

IconPlan.displayName = 'IconPlan';
